import "./src/styles/tailwind.css"
import "./src/styles/prism.css"

import Layout from './src/components/Layout';
import React from 'react';

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};